// [NOTE]
export const USER_FUNCTIONS = {
    MEETING_RAISE_HAND: {
        code: 'MEETING_RAISE_HAND'
    },
    MEETING_PARTICIPANT_LIST_VIEW: {
        code: 'MEETING_PARTICIPANT_LIST_VIEW'
    },
    MEETING_SHARE_SCREEN: {
        code: 'MEETING_SHARE_SCREEN'
    },
    MEETING_FULL_SCREEN: {
        code: 'MEETING_FULL_SCREEN'
    },
    MEETING_INVITE_USER: {
        code: 'MEETING_INVITE_USER'
    },
    MEETING_DEVICE_SETTING: {
        code: 'MEETING_DEVICE_SETTING'
    },
    MEETING_NOTIFICATION_SOUND_SETTING: {
        code: 'MEETING_NOTIFICATION_SOUND_SETTING'
    },
    MEETING_STATISTICS: {
        code: 'MEETING_STATISTICS'
    },
    MEETING_GRID_LAYOUT: {
        code: 'MEETING_GRID_LAYOUT'
    },
    MEETING_PARTICIPANTS_LIMIT: {
        code: 'MEETING_PARTICIPANTS_LIMIT'
    },
    MEETING_MAIN_SPEAKER_LAYOUT: {
        code: 'MEETING_MAIN_SPEAKER_LAYOUT'
    },
    MEETING_BREAKOUT_ROOM: {
        code: 'MEETING_BREAKOUT_ROOM'
    },
    MANAGE_CALL_SIP: {
        code: 'MANAGE_CALL_SIP'
    },
    SIP_CONNECTION: {
        code: 'SIP_CONNECTION'
    },
    MANAGE_WHITEBOARD_CREATE_LIMIT: {
        code: 'MANAGE_WHITEBOARD_CREATE_LIMIT'
    },
    MANAGE_LIMIT_CONCURRENT_MEETING: {
        code: 'MANAGE_LIMIT_CONCURRENT_MEETING'
    },
    CASCADE_CONNECTION_LIMIT: {
        code: 'CASCADE_CONNECTION_LIMIT'
    }
};
export const USER_CONFIG = {
    DURATION_MEETING_MIN_TO_SHOW_FEEDBACK: 'DURATION_MEETING_MIN_TO_SHOW_FEEDBACK',
    ENABLE_SHOW_FEEDBACK: 'ENABLE_SHOW_FEEDBACK'
};
